import { apiClient as api } from "./client";
import type { SuperAdminOrganization, SuperAdminUser, SuperAdminOrgDetail, SuperAdminUserDetail, ImpersonateResponse } from "@/types/superadmin";

export const superAdminApi = {
  getOrganizations: () => api.get<SuperAdminOrganization[]>("/api/superadmin/organizations"),
  getUsers: () => api.get<SuperAdminUser[]>("/api/superadmin/users"),
  getOrganizationDetail: (id: string) => api.get<SuperAdminOrgDetail>(`/api/superadmin/organizations/${id}`),
  getUserDetail: (id: string) => api.get<SuperAdminUserDetail>(`/api/superadmin/users/${id}`),
  impersonate: (userId: string) => api.post<ImpersonateResponse>(`/api/superadmin/impersonate/${userId}`),
  deleteUser: (userId: string) => api.delete(`/api/superadmin/users/${userId}`),
  deleteOrganization: (orgId: string) => api.delete(`/api/superadmin/organizations/${orgId}`),
};
